<div class="discount-table-wrapper">
  <table class="discount-table" data-testid="custom-discount-table">
    <thead>
      <tr>
        <th class="sortable" (click)="sortByCreatedDate.emit()">
          <span class="th-label">
            Created Date
            <img [src]="sortIcon" class="sort-icon" alt="Sort by created date" />
          </span>
        </th>
        <th>Order ID</th>
        <th>Customer Name</th>
        <th>Discount Amount</th>
        <th>Applied By</th>
        <th>Discount Name</th>
        <th>Reason</th>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let row of rows; trackBy: trackByOrder">
        <td>{{ row.created_at | date: 'MMM d y, h:mma' }}</td>
        <td>
          <button
            type="button"
            class="order-link"
            [attr.aria-label]="'View order ' + row.order_id"
            (click)="viewOrder.emit(row)"
          >
            {{ displayOrderId(row) }}
          </button>
        </td>
        <td>{{ row.customer_name || '-' }}</td>
        <td>{{ amount(row) }}</td>
        <td>{{ row.applied_by || '-' }}</td>
        <td>{{ row.discount_name || '-' }}</td>
        <td>{{ reason(row) }}</td>
      </tr>
    </tbody>
  </table>
</div>
